module.exports = __webpack_public_path__ + "static/media/01.61a49bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/volumetric/camera/01.png
// module id = 630
// module chunks = 0